import { Avatar, Box, ClickAwayListener, Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import React, { useState, MouseEvent } from 'react';
import { logout } from 'common/utils/roles';
import { getAvatar, stringAvatar } from './common/utils';
import { EditIcon } from '../../../assets/svg';
import { UserInfoWithLzPzus } from '../../../api';
import { UserPopper } from '../UserPopper/UserPopper';
import { useStyles as useStylesBase } from './common/styles/base';
import { useStyles as useStylesMobile } from './common/styles/mobile';
import { Link } from '../Link/Link';

interface IProp {
  user: UserInfoWithLzPzus;
  compact?: boolean;
}

export const HeaderProfile: React.FC<IProp> = ({ user, compact }) => {
  const classesBase = useStylesBase();
  const classesMobile = useStylesMobile();
  const theme = useTheme();
  const matchesTablet = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = { ...classesBase, ...classesMobile };

  const [anchorPopper, setAnchorPopper] = useState<null | SVGSVGElement>(null);
  

  const popperHandle = (e: MouseEvent<SVGSVGElement>) => {
    setAnchorPopper(e.currentTarget);
  };

  return (
    <ClickAwayListener onClickAway={() => setAnchorPopper(null)}>
      <Box className={classes.userInfo}>
        <Grid container className={classes.navHeader} style={{ marginTop: 20 }}>
          <Box className={classes.root}>
            <Box className={classes.avatar}>
              {user && user.avatarId ? (
                <Avatar src={getAvatar(user.avatarId)} style={{ width: 40, paddingLeft: 2 }} />
              ) : (
                <Avatar {...stringAvatar(`${user.surname} ${user.name}`)} />
              )}
              <div role='avatarIcon' className={classes.avatarInner}>
                <span style={{ top: 15, left: 15 }}>
                  <EditIcon onClick={e => popperHandle(e)} />
                </span>
              </div>
            </Box>
            {!compact && (
              <Box style={{ marginLeft: 8 }}>
                <Box display='flex' flexWrap='wrap' color='#333333'>
                  <Typography variant='body1' style={{ marginRight: 3 }} className={classes.profile}>
                    {user.surname}
                  </Typography>
                  <Typography variant='body1' className={classes.profile}>
                    {`${user.name[0]}.${user.patronymic ? `${user.patronymic[0]}.` : ''}`}
                  </Typography>
                </Box>
                {!matchesTablet && (
                  <Link onClick={logout} className={classes.logoutButton}>
                    Выход
                  </Link>
                )}
              </Box>
            )}
          </Box>
        </Grid>
        <UserPopper
          open={Boolean(anchorPopper)}
          id={undefined}
          anchorPopper={anchorPopper}
          user={user}
          handleClose={() => setAnchorPopper(null)}
        />
      </Box>
    </ClickAwayListener>
  );
};
